import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createFormatters, toLanguage, type AnyLanguage } from '@lumlab/platform-i18n';

/** Intl formatters for the current interface language and the organization's time zone. */
export function useFormatters(timeZone = 'Europe/Paris') {
    const { i18n } = useTranslation();
    const language: AnyLanguage = i18n.language === 'pseudo' ? 'pseudo' : (toLanguage(i18n.language) ?? 'fr');
    return useMemo(() => createFormatters(language, timeZone), [language, timeZone]);
}
